import { useCallback, useMemo } from "react";

import { useQuery } from "@apollo/client";

import { userFavoritesQueryDocument } from "./user-favorite.gql";

export const useGetUserFavoriteList = ({ workspaceId }: { workspaceId: string }) => {
  const queryResult = useQuery(userFavoritesQueryDocument, {
    variables: { getUserFavoriteListInput: { workspaceId } },
  });

  const favoriteList = useMemo(() => {
    return queryResult.data?.getUserFavoriteList || [];
  }, [queryResult.data?.getUserFavoriteList]);

  const getFavoriteByPageUrl = useCallback(
    ({ pageUrl }: { pageUrl: string }) => {
      return favoriteList.find((favorite) => favorite.pageUrl === pageUrl);
    },
    [favoriteList],
  );

  const isFavorite = useCallback(
    ({ pageUrl }: { pageUrl: string }) => {
      return favoriteList.some((favorite) => favorite.pageUrl === pageUrl);
    },
    [favoriteList],
  );

  return {
    favoriteList,
    getFavoriteByPageUrl,
    isFavorite,
    loading: queryResult.loading,
    error: queryResult.error,
  };
};
